export default function setupArticleProgress(className) {
  const bar = document.querySelector(className);
  if (!bar) return;

  const inner = bar.querySelector('span');
  if (!inner) return;

  const article = document.querySelector('.site-article-content');
  if (!article) return;

  ['resize', 'scroll'].forEach((event) => {
    window.addEventListener(
      event,
      () => {
        const rect = article.getBoundingClientRect();
        const { top, bottom } = rect;
        const doc = document.documentElement;

        inner.style.height = `${
          ((doc.scrollTop - top) / (doc.scrollHeight - (bottom - top))) * 100
        }%`;
      },
      false
    );
  });
}
